var tabs = 'fx_2d2fb1e5_13dx0zc0';

export { tabs };
//# sourceMappingURL=tabs.vanilla.mjs.map
